const BASE_URL = process.env.REACT_APP_BACKEND_API_URL

export const LOGIN_API_URL = `${BASE_URL}auth/signin`; //POST
export const REFRESH_TOKEN_API_URL = `${BASE_URL}auth/refresh`; //POST
export const SIGNUP_API_URL = `${BASE_URL}auth/signup`; //POST
export const GET_SUBSCRIPTION = `${BASE_URL}subscription`; //GET
export const INIT_SUBSCRIPTION = `${BASE_URL}subscription/init`; //POST
export const SUCCESS_SUBSCRIPTION = `${BASE_URL}subscription/success`; //PUT
export const FAILURE_SUBSCRIPTION = `${BASE_URL}subscription/cancel`; //PUT
export const PRACTICE_FRAMEWORK = `${BASE_URL}practiceframework`; //GET
export const DIAGONASTIC_TOOL = `${BASE_URL}diagonastictool`; //GET
export const CREATE_ACCOUNT_API_URL = `${BASE_URL}user/info`; //POST
export const CHANGE_PASSWORD_API_URL = `${BASE_URL}auth/change-password`; // POST
export const MANAGE_PATIENT_API_URL = `${BASE_URL}patientrecord`; //POST
export const MANAGE_PATIENT_INTAKE_FORM_API_URL = `${BASE_URL}patientrecord/intake/doctor`; //POST

export const PATIENT_INFORMATION_API_URL = `${BASE_URL}patientrecord`; //GET
export const PATIENT_AUDIO_API_URL = `${BASE_URL}patientreport/recordsession/`; //POST
// export const PATIENT_REPORT_API_URL = `${BASE_URL}patientrecord/reportcard/` //GET
export const PATIENT_REPORT_API_URL = `${BASE_URL}patientrecord/` //GET
export const PATIENT_PAITENT_REPORT_API_URL = `${BASE_URL}patientreportcard/` //GET
export const PATIENT_PAITENT_REPORT_SAVE_API_URL = `${BASE_URL}patientreportcard/save-report/` //GET

export const REPORT_TYPE_API_URL = `${BASE_URL}reporttype`; //GET
export const UPLOAD_CLICNICAL_INTAKE_DOC = `${BASE_URL}patientrecord/doc`; //GET
export const UPLOAD_CLICNICAL_INTAKE_FILE = `${BASE_URL}patientrecord/record`; //GET
export const UPLOAD_CLICNICAL_INTAKE_SUBMIT = `${BASE_URL}patientrecord/intake`; //post
export const UPLOAD_CLICNICAL_INTAKE_RELEATIVES_DATA = `${BASE_URL}patientrelative/intake-relative`;
export const CHECK_PATIENT_INTAKE_FROM_SUBMIT_API = `${BASE_URL}patientrecord/intake`;
export const PATIENT_FACE_IMAGE_MATCH_API = `${BASE_URL}patientrecord/patient-face`;

export const CHECK_PATIENT_REPORT_STATUS = `${BASE_URL}patientreportcard/check-status`;
export const PATIENT_INTAKE_FROM_RESEND = `${BASE_URL}patientrecord/intake/resent`;

export const UPLOAD_PATIENT_REPORT_RECORD_SESSION = `${BASE_URL}patientreport/recordsession`; //post
export const UPLOAD_PATIENT_REPORT_RECORD_SESSION_SAVE = `${BASE_URL}patientreport`; //post

export const GET_PATIENT_RELATIVES_API_URL = `${BASE_URL}patientrecord`; //post
export const SEND_MAIL_PATIENT_RELATIVES_API_URL = `${BASE_URL}patientrecord/relative/send-mail`; //post
export const VERIFY_RELATIVE_INTAKE_FROM = `${BASE_URL}patientrelative/verify`;
export const SUBMIT_RELATIVE_INTAKE_FROM = `${BASE_URL}patientrelative`;
export const PATINET_DOC_UPLOAD = `${BASE_URL}patientrelative/doc`

export const GET_PATIENT_RELATIVES_SUBMIT_API_URL = `${BASE_URL}patientrecord`; //post

export const VERIFY_RELATIVES_SUBMIT_API_URL = `${BASE_URL}patientrelative/submission-form`;

export const GET_PATIENT_RELATIVES_FILE_API_URL = `${BASE_URL}patientrelative`;
export const UNSUBSCRIBE_USER = `${BASE_URL}user/unsubscribe`; //post
export const DELETE_PATIENT = `${BASE_URL}user`; //post

export const GET_PROMPTS = `${BASE_URL}prompt` //get
export const GET_PROMPTS_BY_TEMPLATE = `${BASE_URL}prompt/by-template` //get

//for report

export const GENERATE_PATIENT_REPORT = `${BASE_URL}patientreportcard/generate_patient_report_new/`;
export const APPROVE_PATIENT_REPORT = `${BASE_URL}patientreportcard/save-final-report/`;
export const EDIT_PATIENT_REPORT = `${BASE_URL}patientreportcard/edit-report/`;

export const GET_SPEAKER_IDENTIFY_REPORT = `${BASE_URL}patientreportcard/speakeridentify/`; //get
export const GET_BACKGROUND_REPORT = `${BASE_URL}patientreportcard/backgroundreport/`; //get
export const GET_BACKGROUND_REPORT_STREAM = `${BASE_URL}patientreportcard/backgroundreport_stream/`; //get
export const GET_HISTORY_REPORT = `${BASE_URL}patientreportcard/history/`; //get

export const GET_COLLATERAL_REPORT = `${BASE_URL}patientreportcard/collateral/`;
export const GET_ASSESMENT_DATA_REPORT = `${BASE_URL}patientreportcard/assessmentdata/`;
export const GET_ASSESMENT_DATA_REPORT_STREAM = `${BASE_URL}patientreportcard/assessmentdata_stream/`;

export const GET_MENNTAL_STATUS_EXAMINATION = `${BASE_URL}patientreportcard/mse/`;
export const GET_MENNTAL_STATUS_EXAMINATION_STREAM = `${BASE_URL}patientreportcard/mse_stream/`;
export const GET_STANRADISED_ASSESSMENT = `${BASE_URL}patientreportcard/standardisedassessment/`;
export const GET_STANRADISED_ASSESSMENT_STREAM = `${BASE_URL}patientreportcard/standardisedassessment_stream/`;
export const GET_CLINICAL_INTERVIEW = `${BASE_URL}patientreportcard/clinicalinterview/`;
export const GET_CLINICAL_INTERVIEW_STREAM = `${BASE_URL}patientreportcard/clinicalinterview_stream/`;
export const GET_FORMULATION = `${BASE_URL}patientreportcard/formulation/`;
export const GET_FORMULATION_STREAM = `${BASE_URL}patientreportcard/formulation_stream/`;
export const GET_DIAGNOSE = `${BASE_URL}patientreportcard/diagnose/`;
export const GET_DIAGNOSE_STREAM = `${BASE_URL}patientreportcard/diagnose_stream/`;
export const GET_RECOMMENDATION = `${BASE_URL}patientreportcard/recommendation/`;
export const GET_RECOMMENDATION_STREAM = `${BASE_URL}patientreportcard/recommendation_stream/`;
export const SEND_PATIENT_ASSESMENT = `${BASE_URL}patientassessment/`;
export const GET_PATIENT_ASSESMENT = `${BASE_URL}patientassessment`;
export const GET_DOCTOR_PATIENT_ASSESMENT = `${BASE_URL}patientassessment/doctor/`;

export const PATIENT_ASSESSMWNT_SUBMIT = `${BASE_URL}patientassessment/submission/`;
export const PATIENT_ASSESSMWNT_RECOMMENDED = `${BASE_URL}patientassessment/recommended/`;
export const PATIENT_ASSESSMWNT_RECOMMENDED_STREAM = `${BASE_URL}patientassessment/recommended_stream/`;
export const PATIENT_ASSESSMWNT_SUMMARY = `${BASE_URL}patientreportcard/`;

export const INITIATE_TWO_STEP_VERIFICATION = `${BASE_URL}auth/initiate-tfa-setup`; //GET
export const CONFIRM_TWO_STEP_VERIFICATION = `${BASE_URL}auth/confirm-tfa-setup`; //POST
export const DISABLE_TWO_STEP_VERIFICATION = `${BASE_URL}auth/disable-tfa`; //GET
export const VERIFY_TWO_STEP_VERIFICATION = `${BASE_URL}auth/verify-tfa`; //GET

export const DELETE_DOCUMENT = `${BASE_URL}patientreport/`; //DELETE

//admin api
export const ADMINPROMPTS = `${BASE_URL}prompt`;

export const ADMINTEMPLATE = `${BASE_URL}template`;

export const FORGET_PASSWOED = `${BASE_URL}auth/forgot-password`; //POST
export const RESET_PASSWOED = `${BASE_URL}auth/reset-password`; //POST
export const GET_USER = `${BASE_URL}user/me`; //GET

export const POST_SUPPORT = `${BASE_URL}supportrequest`;
export const POST_CONTACT_US = `${BASE_URL}contactus`;

export const ADMIN_SUBSCRIPTION = `${BASE_URL}subscription/admin`;

export const ADMIN_USER_CLINICIANS = `${BASE_URL}user/clinicians`;

// --------------------- CMS -------------------
export const ADMIN_CMS_TESTIMONIALS = `${BASE_URL}testimonial`;
export const ADMIN_CMS_TESTIMONIALS_IMAGE_UPLOAD_AWS = `${BASE_URL}aws/upload`;

export const ADMIN_CMS_FAQ = `${BASE_URL}faq`;
export const ADMIN_ALL_CMS = `${BASE_URL}cms/type`;
export const ADMIN_ALL_CMS_UPDATE = `${BASE_URL}cms`;
export const ADMIN_CMS_IMAGE_UPLOAD_AWS = `${BASE_URL}aws/upload`;

export const All_FAQ = `${BASE_URL}faq`;

export const ADMIN_CMS_SOCIAL_MEDIA = `${BASE_URL}cms/social-media`;

// ------------------ WHISPER IMPLIMENTATION---------------

export const WHISPER_LIVE_TRANSCRIPTION = `${BASE_URL}patientreport/whisper/live-transcription`; // POST
export const WHISPER_LIVE_TRANSCRIPTION_SUBMIT = `${BASE_URL}patientreport/whisper/finalize`; // POST

export const VALIDATE_URL = `${BASE_URL}cms/validate-url`; // GET

